import React from 'react';
import { FormattedMessage } from 'react-intl';
import { localizable } from '../Localization';

const RoundDateDisplay = ({
  end,
  duration,
  preposition = 'until',
  format = 'ddd ll HH:mm',
}) => {
  return (
    <FormattedMessage
      id="RoundDateDisplay::format"
      values={{
        preposition: preposition,
        hasEnd: !!end,
        end: !end ? null : end.toFormatedDateString(format),
        duration,
      }}
    />
  );
};

export default localizable(RoundDateDisplay);



// WEBPACK FOOTER //
// ./src/app/components/RoundDateDisplay/index.jsx